import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import SkyddadRoute from './components/SkyddadRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import AterstallLosenord from './pages/AterstallLosenord';
import Idag from './pages/Idag';
import RestaurangStartsida from './pages/RestaurangStartsida';
import RegistreraAktivitet from './pages/RegistreraAktivitet';
import Admin from './pages/Admin';
import KundVy from './pages/Kund';
import MinaKunder from './pages/MinaKunder';
import AllaKunder from './pages/AllaKunder';
import AttKoppla from './pages/AttKoppla';
import NyaFortnoxKunder from './pages/NyaFortnoxKunder';
import LagtLagersaldo from './pages/LagtLagersaldo';
import Artikelmatchning from './pages/Artikelmatchning';
import Dubbletter from './pages/Dubbletter';
import Inlasningsfel from './pages/Inlasningsfel';
import Handelselogg from './pages/Handelselogg';
import Statistik from './pages/Statistik';
import Profil from './pages/Profil';
import RegistreraKund from './pages/RegistreraKund';
import Anbudskalender from './pages/Anbudskalender';
import AnbudDashboard from './pages/AnbudDashboard';
import Placeholder from './pages/Placeholder';
import KanalInkopareLista from './pages/KanalInkopare';
import KanalInkopareDetalj from './pages/KanalInkopareDetalj';
import InkopLista from './pages/InkopLista';
import InkopDetalj from './pages/InkopDetalj';
import InkopProducenter from './pages/InkopProducenter';
import InkopProducent from './pages/InkopProducent';
import InkopAttAtgarda from './pages/InkopAttAtgarda';
import InkopPrissattning from './pages/InkopPrissattning';
import InkopStartsida from './pages/InkopStartsida';
import InkopPlan from './pages/InkopPlan';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/aterstall-losenord" element={<AterstallLosenord />} />
          <Route path="/" element={
            <SkyddadRoute>
              <Layout />
            </SkyddadRoute>
          }>
            <Route index element={<Navigate to="/idag" replace />} />
            {/* Startsidan är en översikt (3 nov 2026); listan med avbockning ligger under Att göra. */}
            <Route path="idag" element={<RestaurangStartsida />} />
            <Route path="att-gora" element={<Idag />} />
            <Route path="registrera" element={<RegistreraAktivitet />} />
            <Route path="admin" element={<Admin />} />
            <Route path="kund/:kund_id" element={<KundVy />} />
            <Route path="att-folja-upp" element={<Navigate to="/att-gora" replace />} />
            <Route path="mina-kunder" element={<MinaKunder />} />
            <Route path="alla-kunder" element={<AllaKunder />} />
            <Route path="att-koppla" element={<AttKoppla />} />
            <Route path="nya-fortnox-kunder" element={<NyaFortnoxKunder />} />
            <Route path="statistik" element={<Statistik />} />
            <Route path="profil" element={<Profil />} />
            <Route path="registrera-kund" element={<RegistreraKund />} />
            <Route path="anbud" element={<AnbudDashboard />} />
            <Route path="anbudskalender" element={<Anbudskalender />} />
            <Route path="anbud/affarsmojligheter" element={<Placeholder titel="Offertförfrågningar" />} />
            <Route path="anbud/offertpipeline" element={<Placeholder titel="Offerter" />} />
            <Route path="anbud/aktiviteter" element={<KanalInkopareLista />} />
            <Route path="anbud/aktiviteter/:id" element={<KanalInkopareDetalj />} />
            <Route path="anbud/produktlivscykel" element={<Placeholder titel="Produktlivscykel" />} />
            <Route path="anbud/orderhistorik" element={<Placeholder titel="Orderhistorik" />} />
            <Route path="lager" element={<LagtLagersaldo />} />
            <Route path="artikelmatchning" element={<Artikelmatchning />} />
            <Route path="viner-overvagande" element={<Navigate to="/inkop/producenter" replace />} />
            <Route path="dubbletter" element={<Dubbletter />} />
            <Route path="inlasningsfel" element={<Inlasningsfel />} />
            <Route path="handelselogg" element={<Handelselogg />} />
            <Route path="inkop" element={<InkopStartsida />} />
            <Route path="inkop/lista" element={<InkopLista />} />
            <Route path="inkop/lista/:id" element={<InkopDetalj />} />
            <Route path="inkop/producenter" element={<InkopProducenter />} />
            <Route path="inkop/producenter/:id" element={<InkopProducent />} />
            <Route path="inkop/att-atgarda" element={<InkopAttAtgarda />} />
            <Route path="inkop/prissattning" element={<InkopPrissattning />} />
            <Route path="inkop/plan" element={<InkopPlan />} />
            <Route path="inkop/arsplan" element={<Navigate to="/inkop/plan" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
